import Modal from '../../mini/Modal'
import React from 'react'
import { H3, H2 } from '../../styled/typography/typography'
import Button from '../../mini/Button'
import { useDispatch } from 'react-redux'
import { hideModal, showModal } from '../../../actions/_modal'
import { ModalStyles } from './styled'

const GuardianErrorModal = ({ response, token }) => {
  const dispatch = useDispatch()

  const handleTryAgain = () => {
    dispatch(hideModal())
    dispatch(showModal('CREATE_GUARDIAN_ACCOUNT', { response, token }))
  }

  return (
    <Modal
      width={508}
      topPx={350}
      autoHeight
      background={'transparent'}
      opacity={'1'}
      boxShadow={'0 0 30px 0 rgba(0,0,0,0.07)'}
    >
      <ModalStyles>
        <div className="center">
          <H2 className="error-heading" style={{ marginBottom: '28px' }}>Error</H2>
          <div>
            <H3 className="error-text">Oops, something went wrong.</H3>
            <H3 className="error-text" style={{ marginBottom: '20px' }}>Please try again.</H3>
          </div>
          <H3 className="error-text" style={{ marginBottom: '28px' }}><a href='mailto:support@opportunityeducation.org'>Contact support</a> if this error persists.</H3>

          <Button
            text="Try Again"
            className="quest-btn btn-a go uncap active"
            onClick={handleTryAgain}
          />
        </div>
      </ModalStyles>
    </Modal>
  )
}

export default GuardianErrorModal
